/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconCheck from '@telus-uds/palette-koodo/build/rn/icons/Check'
const theme = {
  appearances: {
    background: {
      description: 'Defines background related attributes of Card',
      type: 'variant',
      values: [ 'alternative', 'subtle', 'grid', 'feature', 'plain' ]
    },
    borderRadius: { type: 'variant', values: [ 'none', 'small', 'large' ] },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    interactive: { type: 'variant', values: [ true ] },
    isControl: { type: 'variant', values: [ true, false ] },
    padding: {
      type: 'variant',
      values: [ 'narrow', 'intermediate', 'compact', 'custom' ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    },
    style: {
      type: 'variant',
      values: [
        'grid',     'light',
        'lighter',  'lightest',
        'dark',     'darker',
        'darkest',  'feature',
        'feature2', 'feature3',
        'feature4', 'warning',
        'error',    'success'
      ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { interactive: true },
      tokens: { backgroundColor: 'transparent' }
    },
    {
      if: { interactive: true, isControl: true },
      tokens: { borderColor: '#c9c8c8', borderWidth: 1 }
    },
    {
      if: { interactive: true, isControl: true, selected: true },
      tokens: {
        backgroundColor: '#efefef',
        borderColor: '#000000',
        borderWidth: 1,
        iconBackgroundColor: '#c9c8c8',
        iconColor: '#000000',
        inputBackgroundColor: '#c9c8c8'
      }
    },
    {
      if: { hover: true, interactive: true, isControl: true },
      tokens: { iconColor: '#000000' }
    },
    {
      if: {
        focus: false,
        interactive: true,
        isControl: true,
        pressed: false
      },
      tokens: { borderColor: 'rgba(0, 0, 0, 0)', borderWidth: 2 }
    },
    {
      if: {
        hover: true,
        interactive: true,
        isControl: true,
        selected: true
      },
      tokens: {
        iconBackgroundColor: '#c9c8c8',
        iconColor: '#000000',
        inputBackgroundColor: '#c9c8c8'
      }
    },
    { if: { borderRadius: 'none' }, tokens: { borderRadius: 0 } },
    { if: { borderRadius: 'small' }, tokens: { borderRadius: 4 } },
    { if: { borderRadius: 'large' }, tokens: { borderRadius: 8 } },
    {
      if: { background: 'alternative' },
      tokens: { backgroundColor: '#e0d8fc', borderRadius: 8, borderWidth: 0 }
    },
    {
      if: { background: 'subtle' },
      tokens: { backgroundColor: '#a1ed00', borderWidth: 0 }
    },
    {
      if: { background: 'grid' },
      tokens: { borderColor: '#000000', borderWidth: 1 }
    },
    {
      if: { background: 'feature' },
      tokens: { backgroundColor: '#ffad00', borderRadius: 8, borderWidth: 0 }
    },
    {
      if: { background: 'plain' },
      tokens: { backgroundColor: '#ffffff', borderWidth: 0 }
    },
    {
      if: { style: 'grid' },
      tokens: { borderColor: '#000000', borderWidth: 1 }
    },
    {
      if: { style: 'light' },
      tokens: { backgroundColor: '#efefef', borderWidth: 0 }
    },
    {
      if: { style: 'lighter' },
      tokens: {
        backgroundColor: '#fafafa',
        borderColor: '#efefef',
        borderWidth: 2
      }
    },
    {
      if: { style: 'lightest' },
      tokens: { backgroundColor: '#ffffff', borderWidth: 0 }
    },
    {
      if: { style: 'dark' },
      tokens: { backgroundColor: '#000000', borderWidth: 0 }
    },
    {
      if: { style: 'darker' },
      tokens: { backgroundColor: '#000000', borderWidth: 0 }
    },
    {
      if: { style: 'darkest' },
      tokens: { backgroundColor: '#000000', borderWidth: 0 }
    },
    {
      if: { style: 'feature' },
      tokens: { backgroundColor: '#a1ed00', borderWidth: 0 }
    },
    {
      if: { style: 'feature2' },
      tokens: { backgroundColor: '#e0d8fc', borderRadius: 8, borderWidth: 0 }
    },
    {
      if: { style: 'feature3' },
      tokens: { backgroundColor: '#ffad00', borderRadius: 8, borderWidth: 0 }
    },
    {
      if: { style: 'feature4' },
      tokens: { backgroundColor: '#2dccd3', borderWidth: 0 }
    },
    {
      if: { style: 'warning' },
      tokens: {
        backgroundColor: '#fff5d2',
        borderColor: '#f8c100',
        borderWidth: 2
      }
    },
    {
      if: { style: 'error' },
      tokens: {
        backgroundColor: '#fcd3c6',
        borderColor: '#f3592b',
        borderWidth: 2
      }
    },
    {
      if: { style: 'success' },
      tokens: {
        backgroundColor: '#c5f2cc',
        borderColor: '#1c7b2b',
        borderWidth: 2
      }
    },
    {
      if: { viewport: [ 'md', 'lg', 'xl' ] },
      tokens: {
        paddingBottom: 48,
        paddingLeft: 32,
        paddingRight: 32,
        paddingTop: 48
      }
    },
    {
      if: { interactive: true, viewport: [ 'md', 'lg', 'xl' ] },
      tokens: {
        paddingBottom: 45,
        paddingLeft: 29,
        paddingRight: 29,
        paddingTop: 45
      }
    },
    {
      if: { padding: 'narrow' },
      tokens: {
        paddingBottom: 24,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 24
      }
    },
    {
      if: { interactive: true, padding: 'narrow' },
      tokens: {
        paddingBottom: 21,
        paddingLeft: 13,
        paddingRight: 13,
        paddingTop: 21
      }
    },
    {
      if: { padding: 'narrow', viewport: [ 'md', 'lg', 'xl' ] },
      tokens: {
        paddingBottom: 32,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 32
      }
    },
    {
      if: {
        interactive: true,
        padding: 'narrow',
        viewport: [ 'md', 'lg', 'xl' ]
      },
      tokens: {
        paddingBottom: 29,
        paddingLeft: 13,
        paddingRight: 13,
        paddingTop: 29
      }
    },
    {
      if: { padding: 'intermediate' },
      tokens: {
        paddingBottom: 24,
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 24
      }
    },
    {
      if: { interactive: true, padding: 'intermediate' },
      tokens: {
        paddingBottom: 21,
        paddingLeft: 21,
        paddingRight: 21,
        paddingTop: 21
      }
    },
    {
      if: { padding: 'intermediate', viewport: [ 'md', 'lg', 'xl' ] },
      tokens: {
        paddingBottom: 32,
        paddingLeft: 32,
        paddingRight: 32,
        paddingTop: 32
      }
    },
    {
      if: {
        interactive: true,
        padding: 'intermediate',
        viewport: [ 'md', 'lg', 'xl' ]
      },
      tokens: {
        paddingBottom: 29,
        paddingLeft: 29,
        paddingRight: 29,
        paddingTop: 29
      }
    },
    {
      if: { padding: 'compact' },
      tokens: {
        paddingBottom: 16,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 16
      }
    },
    {
      if: { interactive: true, padding: 'compact' },
      tokens: {
        paddingBottom: 13,
        paddingLeft: 13,
        paddingRight: 13,
        paddingTop: 13
      }
    },
    {
      if: { padding: 'custom' },
      tokens: {
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0
      }
    },
    {
      if: {
        focus: false,
        interactive: true,
        isControl: false,
        pressed: false
      },
      tokens: { borderColor: '#ffffff', borderWidth: 2 }
    },
    {
      if: { focus: false, interactive: true, pressed: false },
      tokens: { borderColor: 'rgba(0, 0, 0, 0)', borderWidth: 2 }
    },
    {
      if: { hover: true, interactive: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderColor: 'transparent'
      }
    },
    {
      if: { focus: true, interactive: true },
      tokens: { borderColor: '#000000', borderWidth: 2 }
    },
    {
      if: { interactive: true, pressed: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        borderColor: '#c9c8c8',
        borderWidth: 2
      }
    },
    {
      if: { interactive: true, isControl: false, selected: true },
      tokens: {
        backgroundColor: '#efefef',
        borderColor: '#000000',
        borderWidth: 1
      }
    },
    {
      if: { hover: true, interactive: true, style: 'dark' },
      tokens: { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
    },
    {
      if: { hover: true, interactive: true, style: 'darker' },
      tokens: { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
    },
    {
      if: { hover: true, interactive: true, style: 'darkest' },
      tokens: { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
    },
    {
      if: { interactive: true, pressed: true, style: 'dark' },
      tokens: { backgroundColor: 'rgba(255, 255, 255, 0.2)' }
    },
    {
      if: { interactive: true, pressed: true, style: 'darker' },
      tokens: { backgroundColor: 'rgba(255, 255, 255, 0.2)' }
    },
    {
      if: { interactive: true, pressed: true, style: 'darkest' },
      tokens: { backgroundColor: 'rgba(255, 255, 255, 0.2)' }
    }
  ],
  tokens: {
    backgroundColor: '#ffffff',
    backgroundGradient: null,
    borderColor: '#c9c8c8',
    borderRadius: 8,
    borderWidth: 1,
    contentAlignItems: 'stretch',
    contentFlexGrow: 0,
    contentFlexShrink: 1,
    contentJustifyContent: 'flex-start',
    flex: 1,
    gradient: null,
    icon: PaletteIconCheck,
    iconBackgroundColor: '#efefef',
    iconColor: '#000000',
    iconSize: 20,
    inputBackgroundColor: '#efefef',
    inputBorderColor: 'rgba(0, 0, 0, 0)',
    inputBorderRadius: 4,
    inputBorderWidth: 0,
    inputHeight: 32,
    inputShadow: {
      blur: 2,
      color: 'rgba(0, 0, 0, 0.1)',
      inset: true,
      offsetX: 0,
      offsetY: 2,
      spread: 0
    },
    inputWidth: 32,
    maxHeight: '100%',
    minWidth: null,
    overflowY: 'visible',
    paddingBottom: 32,
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: 32,
    shadow: null
  }
}
export default theme
